import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import React, { useState } from "react";
import SaleFunnelForm from "./components/sale-funnel-form";
import { ISaleFunnelItem } from "src/interface/ISaleFunnelItem";
const validationSchema = Yup.object({
  title: Yup.string().required("این فیلد الزامی است"),
});

const initialValues = {
  title: "",
};

const NewSaleFunnel = ({
  open,
  handleClose,
  refetch,
}: {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
}) => {
  const { user } = useAuth();
  const [salesFunnelItem, setSalesFunnelItem] = useState<ISaleFunnelItem[]>([]);
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "sale-funnel", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutateAsync: insertItemsAsync, isPending: isPendingItems } =
    useMutation({
      mutationFn: async (body: any) => {
        const response = await fetch(API_URL + "sale-funnel-item", {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
          body: JSON.stringify(body),
        });
        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const notifications = useNotifications();

  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      if (salesFunnelItem.length === 0) {
        notifications.show("هیچ آیتمی برای این قیف تعریف نشده است!", {
          key: "err-task",
          severity: "error",
          autoHideDuration: 5000,
        });
        return;
      }

      const res = await insertAsync(values);

      if (res.status === true) {
        salesFunnelItem.map(async (row) => {
          await insertItemsAsync({ ...row, saleFunnelRef: res?.data?.id });
        });
        notifications.show("قیف فروش جدید با موفقیت ثبت شد!", {
          key: "new-task",
          severity: "success",
          autoHideDuration: 5000,
        });

        refetch();
        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-task",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
      setSalesFunnelItem([]);
    },
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
          setSalesFunnelItem([]);
        }}
        maxWidth="xl"
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
        }}
      >
        <DialogTitle>قیف فروش جدید</DialogTitle>
        <DialogContent>
          <SaleFunnelForm
            formik={formik}
            salesFunnelItem={salesFunnelItem}
            setSalesFunnelItem={setSalesFunnelItem}
          />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending || isPendingItems}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleClose();
              setSalesFunnelItem([]);
            }}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewSaleFunnel;
